import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { FilterButton } from './filter-button';
import { DateRangeFilterButton } from './date-range-filter-button';
import { CurrencyRangeFilterButton } from './currency-range-filter-button';
import { NumericRangeFilterButton } from './numeric-range-filter-button';
import { Icon } from '@common/components';

function getFilterLabelFromColumns(key, value, columns) {
  const filterMap = columns.find((column) => column.key === key)?.filters || [];

  const label = filterMap.find((filter) => {
    return filter.value === value || filter.id === value;
  });

  return label ? label.labelText || label.text || label.name : value;
}

function getFormatterFromColumns(key, columns) {
  return columns.find((column) => column.key === key)?.filterFormat;
}

export const TableFilterControls = ({
  filters,
  clearFilter,
  clearAllFilters,
  columns,
}) => {
  const filtersEls = Object.keys(filters)
    .filter((key) => filters[key] !== null)
    .map((key) => {
      const fmtColumns = getFormatterFromColumns(key, columns);

      if (!filters[key]?.length) {
        return [];
      }

      if (fmtColumns === 'dateRange') {
        return (
          <DateRangeFilterButton
            key={key}
            keyName={key}
            startDateArray={filters[key]}
            clearFilter={clearFilter}
          />
        );
      }

      if (fmtColumns === 'currencyRange') {
        return (
          <CurrencyRangeFilterButton
            key={key}
            keyName={key}
            rangeArray={filters[key]}
            clearFilter={clearFilter}
          />
        );
      }

      if (['hoursRange', 'weeksRange'].includes(fmtColumns)) {
        return (
          <NumericRangeFilterButton
            key={key}
            keyName={key}
            rangeArray={filters[key]}
            clearFilter={clearFilter}
            unit={fmtColumns.split('Range')[0]}
          />
        );
      }

      return filters[key].map((value) => {
        let labelName = getFilterLabelFromColumns(key, value, columns);

        if (getFormatterFromColumns(key, columns) === 'id') {
          labelName = value.toUpperCase();
        }

        return (
          <FilterButton
            key={`${key}-${value}`}
            keyName={key}
            value={value}
            clearFilter={clearFilter}
            labelName={labelName}
          />
        );
      });
    })
    .flat();

  return (
    <>
      <div className="table-filter-controls">
        {filtersEls}
        {filtersEls.length > 1 && (
          <Button onClick={clearAllFilters}>
            <Icon icon="xMark" kind="light" />
            Clear All
          </Button>
        )}
      </div>
      <style jsx global>
        {`
          :global(.table-filter-controls) .ant-btn {
            text-transform: capitalize;
          }
          div.table-filter-controls button.ant-btn {
            background-color: ${Colors.midnightLighter};
            color: white;
            margin-right: 5px;
            margin-bottom: 5px;
          }
          div.table-filter-controls button.ant-btn:hover {
            border-color: ${Colors.midnightLighter};
          }
          div.table-filter-controls button.ant-btn:last-child {
            margin-bottom: 12px;
          }
          div.table-filter-controls button.ant-btn .svg-inline--fa {
            margin-right: 6px;
            padding-top: 3px;
          }
        `}
      </style>
    </>
  );
};

TableFilterControls.propTypes = {
  filters: PropTypes.object,
  clearAllFilters: PropTypes.func,
  clearFilter: PropTypes.func,
  filterMap: PropTypes.object,
  columns: PropTypes.array,
};
